import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import AddParticipantEvent from './AddParticipantEvent'

class ParselAddMemberToEvent extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={AddParticipantEvent} {...props}/>
   )
 }
}



export default ParselAddMemberToEvent;
